import { Key, Wifi, Phone, Monitor } from 'lucide-react';

// Note templates
export const NOTE_TEMPLATES = [
  {
    id: 'login',
    name: 'Login-Daten',
    icon: Key,
    content: `<h3>Login-Daten</h3>
<p><strong>System:</strong> [Name des Systems]</p>
<p><strong>URL:</strong> [https://...]</p>
<p><strong>Benutzer:</strong> [...]</p>
<p><strong>Passwort:</strong> [...]</p>
<p></p>`
  },
  {
    id: 'network',
    name: 'Netzwerk/Router',
    icon: Wifi,
    content: `<h3>Netzwerk/Router</h3>
<p><strong>Modell:</strong> [z.B. Fritzbox 7590]</p>
<p><strong>IP-Adresse:</strong> [192.168....]</p>
<p><strong>Admin-User:</strong> [...]</p>
<p><strong>Passwort:</strong> [...]</p>
<p><strong>WLAN-Passwort:</strong> [...]</p>
<p></p>`
  },
  {
    id: 'call',
    name: 'Telefonat',
    icon: Phone,
    content: `<h3>Telefonat vom ${new Date().toLocaleDateString('de-DE')}</h3>
<p><strong>Ansprechpartner:</strong> [...]</p>
<p><strong>Thema:</strong> [...]</p>
<p><strong>Ergebnis:</strong> [...]</p>
<p><strong>Nächste Schritte:</strong> [...]</p>
<p></p>`
  },
  {
    id: 'system',
    name: 'System-Info',
    icon: Monitor,
    content: `<h3>System-Information</h3>
<p><strong>Betriebssystem:</strong> [z.B. Windows 11 Pro]</p>
<p><strong>Software:</strong> [...]</p>
<p><strong>Lizenz:</strong> [...]</p>
<p><strong>Ablaufdatum:</strong> [...]</p>
<p><strong>Anmerkungen:</strong> [...]</p>
<p></p>`
  }
];

// Color palette
export const TEXT_COLORS = [
  { name: 'Schwarz', color: '#000000' },
  { name: 'Grau', color: '#6b7280' },
  { name: 'Rot', color: '#dc2626' },
  { name: 'Orange', color: '#ea580c' },
  { name: 'Gelb', color: '#ca8a04' },
  { name: 'Grün', color: '#16a34a' },
  { name: 'Blau', color: '#2563eb' },
  { name: 'Violett', color: '#9333ea' },
  { name: 'Pink', color: '#db2777' },
];

export const HIGHLIGHT_COLORS = [
  { name: 'Gelb', color: '#fef08a' },
  { name: 'Grün', color: '#bbf7d0' },
  { name: 'Blau', color: '#bfdbfe' },
  { name: 'Pink', color: '#fbcfe8' },
  { name: 'Orange', color: '#fed7aa' },
  { name: 'Violett', color: '#ddd6fe' },
];
